// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3Pt8Z","text":"SelectPayment_text__301_O","title":"SelectPayment_title__1gsSj","btn":"SelectPayment_btn__3tSrQ"};